import React, { useEffect, useRef, useState } from 'react'
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { InputText } from 'primereact/inputtext';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import { UploadImageData, EditData, viewdata } from '../reduxactions/donorrsactions/DProfileAction';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { fetchDonordata, fetchcoundata, fetchDocdata, RegisterData } from '../reduxactions/donorrsactions/DProfileAction';




var imageuser = require('../assets/images/images.png');

export const DonorProfile = () => {
    //To get session values
    const uid = window.sessionStorage.getItem('uid');
    const usertype = window.sessionStorage.getItem('usertype');
    const userid = window.sessionStorage.getItem('userid');



    const dispatch = useDispatch()
    const toText = (value: any) => value == null ? '' : String(value);

    function handleFileUpload(event: Event) {
        const input = event.target as HTMLInputElement; // Access the input element
        const selectedFile = input.files?.[0]; // Get the selected file safely

    }

    //To get profile data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchDonordata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    //To get countrydata
    const fetchcountrydata = async () => {
        try {
            await dispatch(fetchcoundata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    //To get Attacments data
    const fetchattachDataAsync = async () => {
        try {
            await dispatch(fetchDocdata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    //Calling data once
    useEffectOnce(() => {
        fetchcountrydata();
        fetchDataAsync();
        fetchattachDataAsync();
    }, [dispatch]);

    const data = useSelector((state: RootState) => state.dprofile.data)
    const docdata = useSelector((state: RootState) => state.dprofile.docdata)
    const countrydata = useSelector((state: RootState) => state.dprofile.countrydata)
    console.log("Countrydata:", countrydata)
    const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
        const files = event.files;
        if (files.length > 0) {
            const file = files[0];

            await dispatch(UploadImageData(file, uid) as any);
            toast.current.show({ severity: 'success', summary: 'Success', life: 3000 })
        } else {
        }
        fetchDataAsync()
        setTimeout(() => {
            window.location.reload();
        }, 3000);

    };

    function truncateFileName(fileName: string, maxLength: number): string {
        if (fileName.length > 15) {
            return fileName.substring(0, 15) + '...';
        }
        return fileName;
    }

    const imgdata = useSelector((state: RootState) => state.dprofile.imgdata)
    let imgmessage = '';
    {
        imgdata !== '' && (
            imgmessage = "Profile photo updated successfully"
        )
    }
    const toast = useRef(imgdata);

    //Gender selecction
    const genderoptions = [
        { label: 'Male', value: 'male' },
        { label: 'Female', value: 'female' }
    ]

    //To update Profile
    const [firstname, setfirstName] = useState('');
    const [lastname, setlastName] = useState('');
    const [email, setEmail] = useState('');
    const [gender, setGender] = useState('');
    const [phone, setPhone] = useState<number | any>('');
    const [idcard_no, setIDcard] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [pincode, setPincode] = useState('');

    const [country, setCountry] = useState<string>(''); // Ensure this is a string


    const [paypal, setPaypal] = useState('');
    //const [dataupdatedflag, setdataupdatedflag] = useState(false);


    useEffect(() => {
        if (data.length > 0) {
            setfirstName(toText(data[0].firstname));
            setlastName(toText(data[0].lastname));
            setEmail(toText(data[0].email));
            setGender(toText(data[0].gender));
            setPhone(toText(data[0].phone));
            setIDcard(toText(data[0].idcard_no));
            setAddress(toText(data[0].address));
            setCity(toText(data[0].city));
            setState(toText(data[0].state));
            setPincode(toText(data[0].pincode));
            setCountry(toText(data[0].country));
            setPaypal(toText(data[0].paypal));
        }

    }, [data]);

    const updatedata = useSelector((state: RootState) => state.dprofile.updatedata)
    const toast1 = useRef(updatedata);

    const msgs = useRef(null);
    useEffect(() => {
        if (updatedata && updatedata.length > 0) {
            toast.current.show({ severity: 'info', summary: 'info', detail: updatedata, life: 3000 })

        }
    }, [updatedata]);
    const isFormValid = () => {
        return (
            toText(firstname).trim() !== '' &&
            toText(lastname).trim() !== '' &&
            toText(email).trim() !== '' &&
            toText(gender) !== '' &&
            toText(phone) !== '' &&
            phone.toString().length === 10 &&
            toText(idcard_no).trim() !== '' &&
            toText(address).trim() !== '' &&
            toText(city).trim() !== '' &&
            toText(state).trim() !== '' &&
            toText(pincode).trim() !== '' &&
            toText(country) !== '' &&
            toText(paypal).trim() !== ''
        );
    };


    const donorprofile = async () => {
        try {
            await dispatch(EditData(firstname, lastname, email, gender, phone, idcard_no, address, city, state, pincode, country, paypal, uid) as any);
            //setdataupdatedflag(true);

        } catch (error) {
            console.log("error while updating profile", error)
        }
        fetchDataAsync()
        // setTimeout(() => {
        //     // window.location.reload();
        // }, 3000);


    }


    const [globalFilter, setGlobalFilter] = useState('');


    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
    }


    const viewupload = (rowData: any) => {
        console.log("RowData:", rowData)
        assignData.current = { did: rowData.DocID }

        setfield(true);
        fetchDataAsyncdialog()
    };
    const assignData = useRef({ did: '' })

    const fetchDataAsyncdialog = async () => {
        try {
            const { did } = assignData.current;
            console.log("DocID", did)
            await dispatch(viewdata(did) as any);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    }
    const regdata = useSelector((state: RootState) => state.dprofile.regdata)
    const toast2 = useRef(regdata);

    const msgs1 = useRef(null);
    useEffect(() => {
        if (regdata && regdata.length > 0) {
            toast.current.show({ severity: 'info', summary: 'info', detail: regdata, life: 3000 })

        }
    }, [regdata]);

    const Applyprofile = async () => {
        try {
            await dispatch(RegisterData(firstname, lastname, email, gender, phone, idcard_no, address, city, state, pincode, country, paypal, uid) as any);
            fetchDataAsync();

            // setdataupdatedflag(false);
        }
        catch (error) {
            console.log("error while updating profile", error)
        }
        // setTimeout(() => {
        //     window.location.reload();
        // }, 3000);
    }

    const dataview = useSelector((state: RootState) => state.dprofile.dataview)

    const navigate = useNavigate();

    const Donates = () => {
        const url = `/donations`;
        navigate(url);
    };

    const handlePhoneChange = (e: any) => {
        const inputPhone = e.target.value;
        // Using regex to keep only digits and limiting to 10 digits
        const formattedPhone = inputPhone.replace(/\D/g, '').slice(0, 10);
        setPhone(formattedPhone);
    };

    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/donorprofile.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        {/* <section className="content-header"> */}
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Profile</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        {/* </section> */}
                        <section className="content">
                            {data.map((response: any) =>
                                <div className="grid" key={response.idcard_no}>
                                    <div className="col-12 md:col-3">
                                        <div className="card flex flex-column align-items-center p-4 border-round shadow-1 bg-white">
                                            <div className="relative mb-3">
                                                <img
                                                    src={response.photo ? response.photo : imageuser}
                                                    alt="Profile"
                                                    className="shadow-2 border-circle border-3 border-white"
                                                    style={{
                                                        width: '100px',
                                                        height: '80px',
                                                        objectFit: 'cover'
                                                    }}
                                                />
                                            </div>
                                            <h3 className="m-0 text-900 font-semibold text-xl text-center">
                                                {response.firstname}
                                            </h3>
                                            <p className="text-500 font-medium text-sm mb-4 mt-1">
                                                Donor Profile
                                            </p>
                                            <div className="w-full">
                                                <FileUpload
                                                    mode="basic"
                                                    name="selectedFile"
                                                    auto
                                                    customUpload
                                                    accept="image/*"
                                                    maxFileSize={1000000}
                                                    uploadHandler={UploadManagerImage}
                                                    chooseLabel="Change Photo"
                                                    className="p-button-sm p-button-outlined w-full"
                                                />
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-9" >
                                        <Panel
                                            header="Personal Details"
                                            toggleable
                                            className="mb-4 shadow-1"
                                        >
                                            <div className="grid">
                                                <div className="col-12 md:col-5">
                                                    <h2 className="text-left text-900 font-bold">
                                                        PROFILE ({response.status})
                                                    </h2>
                                                </div>
                                            </div>
                                            <Card className="surface-card border-round shadow-2">
                                                <div className="grid p-fluid">

                                                    {/* Left Column */}
                                                    <div className="col-12 md:col-6 px-4">

                                                        <div className="field grid mb-4">
                                                            <label htmlFor="fname" className="col-12 md:col-12 text-center text-800 font-semibold mb-2">First Name</label>
                                                            <div className="col-12">
                                                                <InputText id="fname" data-testid="firstname-input" type="text" placeholder="Enter First Name" value={firstname} onChange={(e) => setfirstName(e.target.value)} />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label htmlFor="lname" className="col-12 md:col-12 text-center text-800 font-semibold mb-2">Last Name</label>
                                                            <div className="col-12">
                                                                <InputText id="lname" data-testid="lastname-input" type="text" placeholder="Enter Last Name" value={lastname} onChange={(e) => setlastName(e.target.value)} />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label htmlFor="email" className="col-12 md:col-12 text-center text-800 font-semibold mb-2">E-mail</label>
                                                            <div className="col-12">
                                                                <InputText id="email" data-testid="email-input" type="text" placeholder="Enter Email" disabled value={email} className="bg-gray-100" />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label htmlFor="gender" className="col-12 md:col-12 text-center text-800 font-semibold mb-2">Gender</label>
                                                            <div className="col-12">
                                                                <Dropdown id="gender" data-testid="gender-select" value={gender} onChange={(e) => setGender(e.value)} options={genderoptions} optionLabel="label" style={{ textAlign: 'left' }} optionValue='value' placeholder="Select Gender" />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label htmlFor="phone" className="col-12 md:col-12 text-center text-800 font-semibold mb-2">Phone Number</label>
                                                            <div className="col-12">
                                                                <InputText id="phone" data-testid="phone-input" type="tel" value={phone} onChange={handlePhoneChange} placeholder="Enter Phone Number" />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label htmlFor="cardno" className="col-12 md:col-12 text-center text-800 font-semibold mb-2">ID-Card No.</label>
                                                            <div className="col-12">
                                                                <InputText id="cardno" data-testid="idcard-input" type="text" placeholder="Enter ID-Card No" value={idcard_no} onChange={(e) => setIDcard(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Right Column */}
                                                    <div className="col-12 md:col-6 px-4">

                                                        <div className="field grid mb-4">
                                                            <label htmlFor="add" className="col-12 md:col-12 text-center text-800 font-semibold mb-2">Address</label>
                                                            <div className="col-12">
                                                                <InputText id="add" data-testid="address-input" type="text" placeholder="Enter Address" value={address} onChange={(e) => setAddress(e.target.value)} />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label htmlFor="city" className="col-12 md:col-12 text-center text-800 font-semibold mb-2">City</label>
                                                            <div className="col-12">
                                                                <InputText id="city" data-testid="city-input" type="text" placeholder="Enter City" value={city} onChange={(e) => setCity(e.target.value)} />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label htmlFor="state" className="col-12 md:col-12 text-center text-800 font-semibold mb-2">State</label>
                                                            <div className="col-12">
                                                                <InputText id="state" data-testid="state-input" type="text" style={{ textAlign: 'left' }} placeholder="Enter State" value={state} onChange={(e) => setState(e.target.value)} />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label htmlFor="pincode" className="col-12 md:col-12 text-center text-800 font-semibold mb-2">Pin Code</label>
                                                            <div className="col-12">
                                                                <InputText id="pincode" data-testid="pin-input" type="text" placeholder="Enter Pincode" value={pincode} onChange={(e) => setPincode(e.target.value)} />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label htmlFor="country" className="col-12 md:col-12 text-center text-800 font-semibold mb-2">Country</label>
                                                            <div className="col-12">
                                                                <Dropdown id="country" data-testid="country-select" style={{ textAlign: 'left' }} value={country || (data.length > 0 && data[0].countryid)} onChange={(e) => setCountry(e.value)} options={countrydata} optionLabel="CountryName" optionValue='CountryID' placeholder="Select a Country" />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label htmlFor="paypal" className="col-12 md:col-12 text-center text-800 font-semibold mb-2">Paypal Account</label>
                                                            <div className="col-12">
                                                                <InputText id="paypal" data-testid="paypal-input" type="text" placeholder="Enter Paypal Account" value={paypal} onChange={(e) => setPaypal(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="flex justify-content-end align-items-center gap-2 mt-4 px-4 pb-2">
                                                    <Button
                                                        label="Save"
                                                        data-testid="save-btn"
                                                        onClick={donorprofile}
                                                        disabled={!isFormValid()}
                                                        severity="info"
                                                    />
                                                    {data.map((response: any, index: any) => (
                                                        <div key={index} className="flex gap-2">
                                                            {response.status === 'REGISTERED' && (
                                                                <Button
                                                                    severity="success"
                                                                    label="Apply"
                                                                    data-testid="apply-btn"
                                                                    onClick={Applyprofile}
                                                                    disabled={!isFormValid()}
                                                                />
                                                            )}
                                                            {response.status === 'REJECT' && (
                                                                <Button
                                                                    severity="success"
                                                                    label="Re-Apply"
                                                                    data-testid="reapply-btn"
                                                                    onClick={Applyprofile}
                                                                    disabled={!isFormValid()}
                                                                />
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </Card>
                                            <br></br>
                                            <Panel header="Attachments" toggleable  >
                                                <div className='grid'>
                                                    <div className="col-12">
                                                        <div className="card flex flex-wrap justify-content">
                                                            <span className="p-input-icon-left">
                                                                <i className="pi pi-search" />
                                                                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                            </span>
                                                        </div>

                                                        <DataTable value={docdata} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                            <Column field="doc_name" sortable header="Title"></Column>
                                                            <Column field="expiry_date" sortable header="Expiry Date"></Column>
                                                            <Column header="Operations" body={(rowData, { rowIndex }) => (
                                                                <div>
                                                                    <Button className='mr-1' data-testid={`view-btn-${rowIndex}`} severity="info" tooltip="View" icon="pi pi-eye" rounded outlined onClick={() => viewupload(rowData)} />

                                                                </div>
                                                            )}></Column>
                                                        </DataTable>
                                                    </div>
                                                </div>
                                            </Panel>
                                        </Panel>
                                    </div>
                                </div>
                            )}
                        </section>
                        <Dialog header="View" data-testid="view-dialog" style={{ width: '50vw' }} visible={acceptfield} onHide={cancelfield}>
                            <div className="modal-header">
                                <Button icon="pi pi-times" className="p-button-text" />
                            </div>
                            <div className="modal-body">
                                {dataview.map((response: any, index: number) =>
                                    <div key={index}>
                                        {response.filetype === 'image' && <img src={response.displayfile} alt="Doc" width="100%" height="auto" />}
                                        {response.filetype !== 'image' &&
                                            <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                                        }
                                    </div>
                                )}
                            </div>
                            <Button label="Close" className="ml-2" severity="secondary" data-testid="view-close-btn" onClick={cancelfield} />
                        </Dialog>
                        <Toast ref={toast} >
                            <Message severity="success" content={imgdata}></Message>
                        </Toast>
                        <Toast ref={toast2} >
                            <Message severity="success" content={regdata}></Message>
                        </Toast>

                    </div>
                </div>
            </div >
        </div >
    )
}
export default DonorProfile
